/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacetData } from '../../models/facet-data';

export interface GetFacetData$Params {
}

export function getFacetData(http: HttpClient, rootUrl: string, params?: GetFacetData$Params, context?: HttpContext): Observable<StrictHttpResponse<FacetData>> {
  const rb = new RequestBuilder(rootUrl, getFacetData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacetData>;
    })
  );
}

getFacetData.PATH = '/api/facet';
